import { Box } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';
import { colorSkeletonBackground } from 'customColors';

export interface BaseSkeletonProps {
  height?: string;
  marginBottom?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  width?: string;
  backgroundColor?: string;
  styles?: CSSProperties;
}

export const BaseSkeleton = ({
  height = '24px',
  marginBottom = '10px',
  marginTop = '10px',
  marginLeft = '0px',
  marginRight = '0px',
  width = '100%',
  backgroundColor = colorSkeletonBackground,
  styles = {},
}: BaseSkeletonProps): ReactElement => (
  <Box
    sx={{
      height,
      marginBottom,
      marginTop,
      marginLeft,
      marginRight,
      width,
      backgroundColor,
      ...styles,
    }}
  />
);
